module.exports = __webpack_public_path__ + "static/media/javea-3.9a84415a.jpg";